import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DiagnosticDataRequest } from 'src/app/models/diagnosticDataRequest';
import { ApiDataService } from 'src/app/shared/services/api.data.service';
import { DiagnosticArticleResponse } from 'src/app/models/diagnosticArticleResponse';
import { DiagnosticComponent } from 'src/app/models/diagnosticComponent';
import { DiagnosticSection } from 'src/app/models/diagnosticSection';

@Injectable({
  providedIn: 'root'
})
export class DiagnosticArticleService {
  constructor(private api: ApiDataService) {

  }

  getArticleData(vin: string, protocol: string, sourceAddress: number, faultCode: number, failureCode: number, failureMode: string, country: string): Observable<DiagnosticArticleResponse> {
    let url = this.api.buildUrl('diagnosticArticle/articleByVehicleAndDTC');

    if (failureMode) {
      url = `${this.api.buildUrl('diagnosticArticle/articleByVehicleAndDTC')}?vin=${vin}&protocol=${protocol}&sourceAddress=${sourceAddress.toString()}&faultCode=${faultCode.toString()}&faultType=${failureMode}&failureCode=${failureCode.toString()}&country=${country}`;
    }
    else {
      url = `${this.api.buildUrl('diagnosticArticle/articleByVehicleAndDTC')}?vin=${vin}&protocol=${protocol}&sourceAddress=${sourceAddress.toString()}&faultCode=${faultCode.toString()}&failureCode=${failureCode.toString()}&country=${country}`;
    }
    
    return this.api.get(url);
  }

  getComponentData(dataRequest: DiagnosticDataRequest): Observable<DiagnosticComponent[]>{
    return this.api.post(this.api.buildUrl('diagnosticarticle/componentByIds'), JSON.stringify(dataRequest));
  }
  
  getSectionData(dataRequest: DiagnosticDataRequest): Observable<DiagnosticSection[]>{
      return this.api.post(this.api.buildUrl('diagnosticarticle/sectionByIds'), JSON.stringify(dataRequest));
  }
}
